var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { faDownload, faTimes } from "@fortawesome/pro-regular-svg-icons";
import { faFilter } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TableView } from "@yodlee/common-components";
import { CalenderConfigs } from "@yodlee/common-components/dist/configurations";
import { TableUtils } from "@yodlee/common-components/dist/utilities";
import { Button, Checkbox, Col, Icon, message, Modal, Row, Spin, Typography } from "antd";
import { cloneDeep } from "lodash";
import moment from "moment";
import React from "react";
import { LabelConfigs } from "../../configurations";
import { DataUtils } from "../../utilities";
moment.updateLocale('en', {
    calendar: CalenderConfigs.MOMENT_CALENDER
});
var BRAND;
(function (BRAND) {
    BRAND[BRAND["SUB_BRAND"] = 1] = "SUB_BRAND";
    BRAND[BRAND["CHANNEL"] = 2] = "CHANNEL";
    BRAND[BRAND["COBRAND"] = 3] = "COBRAND";
    BRAND[BRAND["YODLEE"] = 4] = "YODLEE";
})(BRAND || (BRAND = {}));
var defaultPreferences = { preferences: { widgets: [] } };
var CONTAINER_TYPE = "widgets", CONTAINER_ID = "feature-setting-wdgt", TABLE_ID = "feature-setting-wdgt";
var initialPagination = {
    defaultPageSize: 50,
    defaultCurrent: 1,
    pageSizeOptions: ["50", "100", "200"],
    showSizeChanger: true,
    showQuickJumper: true,
    current: 1,
    pageSize: 50
};
var FeatureList = /** @class */ (function (_super) {
    __extends(FeatureList, _super);
    function FeatureList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            searchFilterKeys: {},
            userPreferenceData: __assign({}, defaultPreferences),
            tablePreferenceData: undefined,
            savedColumnMap: {},
            pagination: __assign({}, initialPagination),
            customersData: [],
            isAllSelected: false,
            isUpdatingCustomers: false,
            disableApply: true,
            originalCustomersData: [],
        };
        _this.getCustomersData = function () {
            var authentication = _this.props.authentication;
            _this.setState({
                customersData: undefined,
                originalCustomersData: undefined,
                isAllSelected: false
            });
            DataUtils.featuresList(authentication).getAllCustomers().then(function (data) {
                var _a;
                var customersData = [];
                var isAllSelected = true;
                (_a = (data || [])) === null || _a === void 0 ? void 0 : _a.forEach(function (customerData, channelIndex) {
                    var children = ((customerData === null || customerData === void 0 ? void 0 : customerData.brands) || []).map(function (brand, subBrandIndex) {
                        var _a, _b, _c;
                        if (!brand.isSrRoutingEnabled && isAllSelected) {
                            isAllSelected = false;
                        }
                        return ({
                            uKey: "".concat(channelIndex, "-").concat(subBrandIndex),
                            name: brand === null || brand === void 0 ? void 0 : brand.name,
                            id: brand === null || brand === void 0 ? void 0 : brand.id,
                            isSrRoutingEnabled: brand === null || brand === void 0 ? void 0 : brand.isSrRoutingEnabled,
                            updatedOn: brand === null || brand === void 0 ? void 0 : brand.updatedOn,
                            srRoutingOriginalValue: brand === null || brand === void 0 ? void 0 : brand.isSrRoutingEnabled,
                            supportPartner: ((_a = brand === null || brand === void 0 ? void 0 : brand.supportPartner) === null || _a === void 0 ? void 0 : _a.id) != null ? {
                                id: (_b = brand === null || brand === void 0 ? void 0 : brand.supportPartner) === null || _b === void 0 ? void 0 : _b.id,
                                name: (_c = brand === null || brand === void 0 ? void 0 : brand.supportPartner) === null || _c === void 0 ? void 0 : _c.name
                            } : undefined
                        });
                    });
                    delete customerData.brands;
                    customersData.push(__assign(__assign({}, customerData), { uKey: "".concat(channelIndex), children: (children || []).length > 0 ? children : undefined }));
                });
                _this.setState({
                    customersData: customersData,
                    originalCustomersData: customersData,
                    isAllSelected: isAllSelected
                });
            }).catch(function (e) {
                _this.setState({
                    customersData: [],
                    originalCustomersData: [],
                    isAllSelected: false,
                });
            });
        };
        _this.componentDidMount = function () {
            var authentication = _this.props.authentication;
            DataUtils.onload(authentication).get(undefined, false).then(function (onload) {
                _this.setState({ onload: onload });
            });
            _this.getCustomersData();
        };
        _this.mapSavedPreferencesToTable = function (preferences) {
            var featureSettingsTable = TableUtils.getRequiredTable(cloneDeep(preferences), CONTAINER_TYPE, CONTAINER_ID, TABLE_ID);
            if (featureSettingsTable) {
                var columnMap = TableUtils.columnsToMap(featureSettingsTable === null || featureSettingsTable === void 0 ? void 0 : featureSettingsTable.columns);
                _this.setState({
                    savedColumnMap: columnMap === null || columnMap === void 0 ? void 0 : columnMap.columnMap,
                    searchFilterKeys: columnMap === null || columnMap === void 0 ? void 0 : columnMap.filteredFields,
                    userPreferenceData: preferences,
                    tablePreferenceData: featureSettingsTable,
                    pagination: __assign(__assign({}, _this.state.pagination), featureSettingsTable === null || featureSettingsTable === void 0 ? void 0 : featureSettingsTable.pagination)
                });
            }
            else
                _this.setState({ userPreferenceData: preferences, tablePreferenceData: {} });
        };
        _this.onTablePreferenceChanges = function (preferenceUpdates) {
            var _a;
            var existingUserPref = _this.state.userPreferenceData;
            var formattedWidgets = TableUtils.formatTablePreferences(cloneDeep(existingUserPref), preferenceUpdates, CONTAINER_TYPE, CONTAINER_ID, TABLE_ID);
            var currentPreferences = cloneDeep(existingUserPref) || {};
            if (currentPreferences === null || currentPreferences === void 0 ? void 0 : currentPreferences.preferences)
                currentPreferences.preferences[CONTAINER_TYPE] = formattedWidgets;
            else
                currentPreferences.preferences = (_a = {}, _a[CONTAINER_TYPE] = formattedWidgets, _a);
            DataUtils.preference(_this.props.authentication).put(currentPreferences)
                .then(function (response) {
                console.debug("PREFERENCES SAVED!");
            }).catch(function (error) {
                console.error(error);
            });
        };
        _this.filterResults = function (data, originalSearchKey) {
            var _a, _b, _c, _d, _e, _f, _g;
            var searchKey = (originalSearchKey || "").trim().toLowerCase();
            if (searchKey.length > 0) {
                if (((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.name) === null || _a === void 0 ? void 0 : _a.toString()) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === null || _c === void 0 ? void 0 : _c.includes(searchKey)) || ((_f = (_e = (_d = data === null || data === void 0 ? void 0 : data.id) === null || _d === void 0 ? void 0 : _d.toString()) === null || _e === void 0 ? void 0 : _e.toLowerCase()) === null || _f === void 0 ? void 0 : _f.includes(searchKey))) {
                    return true;
                }
                else if (((data === null || data === void 0 ? void 0 : data.children) || []).length > 0) {
                    return (_g = data === null || data === void 0 ? void 0 : data.children) === null || _g === void 0 ? void 0 : _g.find(function (child) {
                        var _a, _b, _c, _d, _e, _f;
                        return ((_c = (_b = (_a = child === null || child === void 0 ? void 0 : child.name) === null || _a === void 0 ? void 0 : _a.toString()) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === null || _c === void 0 ? void 0 : _c.includes(searchKey)) ||
                            ((_f = (_e = (_d = child === null || child === void 0 ? void 0 : child.id) === null || _d === void 0 ? void 0 : _d.toString()) === null || _e === void 0 ? void 0 : _e.toLowerCase()) === null || _f === void 0 ? void 0 : _f.includes(searchKey));
                    });
                }
                return false;
            }
            else {
                return true;
            }
        };
        _this.filterData = function (originalSearchKey) {
            var originalCustomersData = _this.state.originalCustomersData;
            _this.setState({
                customersData: undefined
            });
            var newCustomerData = cloneDeep(originalCustomersData || []);
            var isAllSelected = true;
            var searchKey = (originalSearchKey || "").trim().toLowerCase();
            if (searchKey.length > 0) {
                //filter all channel
                newCustomerData = newCustomerData.filter(function (data) { return _this.filterResults((data || []), searchKey); });
                //filter all subbrand/children
                newCustomerData = newCustomerData.map(function (data) {
                    var _a, _b;
                    if ((data.children || []).length > 0) {
                        var filteredChildren = (_a = data.children) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return _this.filterResults((item || []), searchKey); });
                        if ((filteredChildren || []).length > 0) {
                            data.children = filteredChildren;
                        }
                    }
                    if (((_b = data.children) === null || _b === void 0 ? void 0 : _b.length) === 0) {
                        delete data.children;
                        isAllSelected = false;
                    }
                    if (data.children) {
                        var srRoutingDisabled = data.children.find(function (item) { return !item.isSrRoutingEnabled; });
                        if (srRoutingDisabled && isAllSelected) {
                            isAllSelected = false;
                        }
                    }
                    return data;
                });
            }
            else {
                var srRoutingDisabled = newCustomerData.find(function (item) {
                    var found = false;
                    if (item.children) {
                        var srRoutingDisabledForChildren = item.children.find(function (childrenItem) { return !childrenItem.isSrRoutingEnabled; });
                        if (srRoutingDisabledForChildren) {
                            found = true;
                        }
                    }
                    return found;
                });
                if (srRoutingDisabled && isAllSelected) {
                    isAllSelected = false;
                }
            }
            _this.setState({
                customersData: newCustomerData || [],
                isAllSelected: isAllSelected
            });
        };
        _this.onChangeSelection = function (e, record) {
            var _a = _this.state, customersData = _a.customersData, isAllSelected = _a.isAllSelected, disableApply = _a.disableApply;
            var newChangeList = __spreadArray([], customersData || [], true);
            if (disableApply) {
                _this.setState({ disableApply: false });
            }
            //checking/unchecking all subrands if channel is checked/unchecked
            if (((record === null || record === void 0 ? void 0 : record.children) || []).length > 0) {
                newChangeList.forEach(function (data) {
                    if ((data.id).toString() === e.target.id) {
                        ((data === null || data === void 0 ? void 0 : data.children) || []).forEach(function (childData) {
                            childData.isSrRoutingEnabled = e.target.checked;
                            if ((childData === null || childData === void 0 ? void 0 : childData.srRoutingOriginalValue) !== e.target.checked) {
                                childData.isModified = true;
                            }
                            else {
                                childData.isModified = false;
                            }
                        });
                    }
                });
            }
            else {
                newChangeList.forEach(function (data) {
                    if (((data === null || data === void 0 ? void 0 : data.children) || []).length > 0) {
                        ((data === null || data === void 0 ? void 0 : data.children) || []).forEach(function (childData) {
                            if ((childData.id).toString() === e.target.id) {
                                childData.isSrRoutingEnabled = e.target.checked;
                                if ((childData === null || childData === void 0 ? void 0 : childData.srRoutingOriginalValue) !== e.target.checked) {
                                    childData.isModified = true;
                                }
                                else {
                                    childData.isModified = false;
                                }
                            }
                        });
                    }
                });
            }
            var isAllItemsSelected = true;
            if (isAllSelected) {
                if (!e.target.checked) {
                    isAllItemsSelected = false;
                }
            }
            else {
                var srRoutingDisabled = newChangeList.find(function (item) {
                    var found = false;
                    if (item.children) {
                        var srRoutingDisabledForChildren = item.children.find(function (childrenItem) { return !childrenItem.isSrRoutingEnabled; });
                        if (srRoutingDisabledForChildren) {
                            found = true;
                        }
                    }
                    return found;
                });
                if (srRoutingDisabled && isAllItemsSelected) {
                    isAllItemsSelected = false;
                }
            }
            _this.setState({
                customersData: newChangeList,
                isAllSelected: isAllItemsSelected
            });
        };
        _this.onSupportPartnerChange = function (e, record) {
            var _a = _this.state, customersData = _a.customersData, disableApply = _a.disableApply;
            if (disableApply) {
                _this.setState({ disableApply: false });
            }
            var newChangeList = __spreadArray([], customersData || [], true);
            newChangeList.forEach(function (data) {
                var _a;
                if ((data === null || data === void 0 ? void 0 : data.id) === (record === null || record === void 0 ? void 0 : record.id)) {
                    data.isModified = true;
                    data.supportPartner = {
                        id: e
                    };
                }
                else {
                    (_a = data === null || data === void 0 ? void 0 : data.children) === null || _a === void 0 ? void 0 : _a.forEach(function (childData) {
                        if ((childData === null || childData === void 0 ? void 0 : childData.id) === (record === null || record === void 0 ? void 0 : record.id)) {
                            childData.isModified = true;
                            childData.supportPartner = {
                                id: e
                            };
                        }
                    });
                }
            });
            _this.setState({ customersData: newChangeList });
        };
        _this.onSelectAll = function () {
            var _a = _this.state, customersData = _a.customersData, isAllSelected = _a.isAllSelected, disableApply = _a.disableApply;
            var newChangeList = __spreadArray([], customersData || [], true);
            if (disableApply) {
                _this.setState({ disableApply: false });
            }
            newChangeList.forEach(function (data) {
                var _a;
                if (((_a = ((data === null || data === void 0 ? void 0 : data.children) || [])) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    ((data === null || data === void 0 ? void 0 : data.children) || []).forEach(function (childData) {
                        childData.isSrRoutingEnabled = !isAllSelected;
                        if ((childData === null || childData === void 0 ? void 0 : childData.srRoutingOriginalValue) !== !isAllSelected) {
                            childData.isModified = true;
                        }
                        else {
                            childData.isModified = false;
                        }
                    });
                }
            });
            _this.setState({
                customersData: newChangeList,
                isAllSelected: !isAllSelected
            });
        };
        _this.onClickApply = function () {
            var close = Modal.confirm({
                keyboard: false,
                width: "450px",
                title: React.createElement(React.Fragment, null,
                    React.createElement(Typography.Title, { className: "no-margin color-blue-5", level: 3 }, "Are you sure you want to apply these updates?"),
                    React.createElement("div", { className: "align-right", style: { marginTop: "-52px", position: "relative" } },
                        React.createElement(Icon, { onClick: function () { return close.destroy(); }, component: function () { return React.createElement(FontAwesomeIcon, { className: "color-gray-5", icon: faTimes }); } })),
                    React.createElement("br", null),
                    React.createElement("br", null)),
                icon: null,
                cancelButtonProps: { type: "default" },
                cancelText: "Cancel",
                okText: "Yes, apply",
                onOk: function () { return _this.onConfirmApply(); },
                onCancel: function () { }
            });
        };
        _this.onConfirmApply = function () {
            var customersData = _this.state.customersData;
            var _a = _this.props, authentication = _a.authentication, onCustomerUpdate = _a.onCustomerUpdate;
            var dataToUpdate = [];
            (customersData || []).forEach(function (data) {
                var _a;
                if ((data === null || data === void 0 ? void 0 : data.isModified) === true) {
                    dataToUpdate.push({
                        id: data === null || data === void 0 ? void 0 : data.id,
                        updatedOn: data === null || data === void 0 ? void 0 : data.updatedOn,
                        supportPartner: data.supportPartner
                    });
                }
                if (((_a = ((data === null || data === void 0 ? void 0 : data.children) || [])) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    ((data === null || data === void 0 ? void 0 : data.children) || []).forEach(function (childData) {
                        if ((childData === null || childData === void 0 ? void 0 : childData.isModified) === true) {
                            dataToUpdate.push({
                                id: childData === null || childData === void 0 ? void 0 : childData.id,
                                updatedOn: childData === null || childData === void 0 ? void 0 : childData.updatedOn,
                                isSrRoutingEnabled: childData === null || childData === void 0 ? void 0 : childData.isSrRoutingEnabled,
                                supportPartner: childData.supportPartner
                            });
                        }
                    });
                }
            });
            if ((dataToUpdate === null || dataToUpdate === void 0 ? void 0 : dataToUpdate.length) > 0) {
                _this.setState({ isUpdatingCustomers: true });
                DataUtils.featuresList(authentication).updateCustomer(dataToUpdate).then(function (data) {
                    onCustomerUpdate && onCustomerUpdate(data);
                    _this.getCustomersData();
                }).finally(function () {
                    _this.setState({ isUpdatingCustomers: false });
                    window.scrollTo(0, 0);
                });
            }
        };
        _this.onExport = function () {
            var authentication = _this.props.authentication;
            var name = "All Customer Settings";
            var hide = message.loading('Preparing file...', 0);
            DataUtils.featuresList(authentication).export("".concat(name, " - ").concat(moment(new Date()).format("Do MMM, YYYY"), ".csv"), {})
                .finally(function () { return hide(); });
        };
        _this.render = function () {
            var _a = _this.state, onload = _a.onload, customersData = _a.customersData, pagination = _a.pagination, isUpdatingCustomers = _a.isUpdatingCustomers, isAllSelected = _a.isAllSelected, disableApply = _a.disableApply;
            var _b = _this.props, extra = _b.extra, prefix = _b.prefix, suffix = _b.suffix, header = _b.header;
            var editPermission = onload === null || onload === void 0 ? void 0 : onload.isSuperAdmin;
            //column configurations
            var columns = onload && customersData ?
                [
                    {
                        title: "Co-brand",
                        key: "name",
                        dataIndex: "name",
                        width: 90,
                        minWidth: 90,
                        sorter: function (a, b) { return (a.name || "") < (b.name || "") ? -1 : 1; },
                        ellipsis: true,
                    },
                    {
                        title: "Co-brand ID",
                        key: "id",
                        dataIndex: "id",
                        width: 90,
                        minWidth: 90,
                        sorter: function (a, b) { return a.id - b.id; },
                        ellipsis: true,
                    },
                    {
                        title: React.createElement(React.Fragment, null,
                            React.createElement(Checkbox, { onChange: function () { return _this.onSelectAll(); }, className: "padding-right-sm", disabled: !editPermission, checked: isAllSelected }),
                            LabelConfigs.SR_ROUTING),
                        key: "isSrRoutingEnabled",
                        width: 80,
                        minWidth: 80,
                        filterIcon: React.createElement(Icon, { className: "font-size-xl", component: function () { return React.createElement(FontAwesomeIcon, { icon: faFilter }); } }),
                        filters: [
                            { text: 'Selected', value: "true" },
                            { text: 'Unselected', value: "false" }
                        ],
                        onFilter: function (value, record) {
                            if (record.children) {
                                var foundInChild = record === null || record === void 0 ? void 0 : record.children.find(function (record) {
                                    var _a;
                                    var found = ((_a = (record === null || record === void 0 ? void 0 : record.isSrRoutingEnabled)) === null || _a === void 0 ? void 0 : _a.toString()) === value;
                                    if (found) {
                                        return record;
                                    }
                                    return false;
                                });
                                return foundInChild ? true : false;
                            }
                            else {
                                return false;
                            }
                        },
                        render: function (name, record) {
                            var _a, _b, _c, _d;
                            var subBrands = (record === null || record === void 0 ? void 0 : record.children) || [];
                            var selectedRows = subBrands === null || subBrands === void 0 ? void 0 : subBrands.filter(function (subBrand) { return (subBrand === null || subBrand === void 0 ? void 0 : subBrand.isSrRoutingEnabled) === true; });
                            var allSelected = subBrands.length === selectedRows.length;
                            var isChannel = subBrands.length > 0;
                            var brandType = (_d = (_c = (_b = (_a = onload === null || onload === void 0 ? void 0 : onload.financialInstitution) === null || _a === void 0 ? void 0 : _a.brands) === null || _b === void 0 ? void 0 : _b.find(function (brand) { return brand.id === record.id; })) === null || _c === void 0 ? void 0 : _c.type) === null || _d === void 0 ? void 0 : _d.id;
                            return (React.createElement(React.Fragment, null, brandType != BRAND.COBRAND && React.createElement(React.Fragment, null,
                                React.createElement(Checkbox, { id: (record.id).toString(), key: record.id, onChange: function (e) { return _this.onChangeSelection(e, record); }, className: !editPermission ? "indeterminate-disabled padding-right-sm" : "padding-right-sm", onClick: function (e) {
                                        e.stopPropagation();
                                    }, checked: isChannel ? allSelected : record === null || record === void 0 ? void 0 : record.isSrRoutingEnabled, disabled: !editPermission, indeterminate: (selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.length) !== (subBrands === null || subBrands === void 0 ? void 0 : subBrands.length) && (selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.length) > 0 }),
                                "SR routing")));
                        }
                    },
                    /*{
                        title: "Support Partner",
                        key: "supportPartner",
                        dataIndex: "supportPartner.id",
                        width: 90,
                        minWidth: 90,
                        ellipsis: true,
                        render: (id, record) => {
                            let brandType = onload?.financialInstitution?.brands?.find(brand => brand.id === record.id)?.type?.id;
                            return (
                                <React.Fragment>
                                    {
                                        (brandType != BRAND.CHANNEL) && editPermission ? <Select
                                            dropdownClassName="checked-select"
                                            style={{width:'100%'}}
                                            optionFilterProp="children"
                                            onChange={(e) => this.onSupportPartnerChange(e, record)}
                                            suffixIcon={<Icon component={() => <FontAwesomeIcon icon={faChevronDown} />} />}
                                            showSearch={true}
                                            value={id}
                                            allowClear
                                            disabled={!editPermission}
                                            placeholder={FormFieldConfigs.SUPPORT_PARTNER.placeholder}
                                        >
                                            {
                                                (onload?.supportPartners || []).map(supportPartner =>
                                                    <Select.Option key={supportPartner.name} value={supportPartner.id}>
                                                        {supportPartner.name}
                                                    </Select.Option>
                                                )
                                            }
                                        </Select> :
                                        <React.Fragment>
                                            {
                                                (onload?.supportPartners || []).find((supportPartner: SupportPartner) => supportPartner.id === id)?.name
                                            }
                                        </React.Fragment>
    
                                    }
                                </React.Fragment>
                            )
                        }
                    },*/
                    {
                        title: "Last updated",
                        key: "updatedOn",
                        dataIndex: "updatedOn",
                        width: 90,
                        minWidth: 90,
                        ellipsis: true,
                        render: function (updatedOn, record) { return (record === null || record === void 0 ? void 0 : record.updatedOn) ? moment(record === null || record === void 0 ? void 0 : record.updatedOn).calendar() : ""; }
                    }
                ] : [];
            var loadedData = customersData || [];
            return (onload && customersData ?
                React.createElement("div", { className: "cob-perm-tbl" },
                    React.createElement(TableView, { prefix: prefix, suffix: suffix, header: header, defaultColumnKeys: columns.map(function (column) { return (column.key || "").toString(); }), filter: function () { return true; }, onSearchKeyChange: function (key) { return _this.filterData(key); }, searchPlaceholder: "Search", loading: !customersData, data: loadedData || [], getRowKey: function (data) { return data.uKey || data.id.toString(); }, extra: React.createElement(React.Fragment, null,
                            extra,
                            extra && React.createElement("span", { className: "margin-left-sm" }),
                            React.createElement(Button, { type: "link", onClick: function () { return _this.onExport(); } },
                                React.createElement(Icon, { className: "font-size-lg", component: function () { return React.createElement(FontAwesomeIcon, { icon: faDownload }); } }),
                                React.createElement("span", { className: "margin-left-xs" }),
                                "Export")), columns: columns, rowDensity: "default", pagination: pagination, onChange: function (newPagination) {
                            if (newPagination && (newPagination.current !== pagination.current || newPagination.pageSize !== pagination.pageSize)) {
                                _this.setState({ pagination: __assign(__assign({}, pagination), newPagination) });
                            }
                        }, onColumnChange: function () { }, fixedColumns: ["id", "name", "isSrRoutingEnabled", "updatedOn"], tableSetting: false, footer: (customersData === null || customersData === void 0 ? void 0 : customersData.length) > 0 &&
                            React.createElement("div", { style: { textAlign: "right" } },
                                React.createElement(Button, { type: "primary", className: "margin-top-sm", onClick: _this.onClickApply, disabled: isUpdatingCustomers || !editPermission || disableApply, loading: isUpdatingCustomers }, "Apply")) })) :
                React.createElement(Row, { type: "flex", justify: "center", align: "middle", style: { height: "80vh" } },
                    React.createElement(Col, null,
                        React.createElement(Spin, { size: "large", indicator: React.createElement(Icon, { type: "loading" }) }))));
        };
        return _this;
    }
    return FeatureList;
}(React.Component));
export default FeatureList;
//# sourceMappingURL=index.js.map